import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import {
  NgxFileDropEntry,
  FileSystemFileEntry,
  FileSystemDirectoryEntry,
} from 'ngx-file-drop';
import { mensajesArrayExcel, RequestProductsAdd } from 'src/app/_models'
import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'

import * as XLSX from 'xlsx'
@Component({
  selector: 'app-import-receiving-excel-reference',
  templateUrl: './import-receiving-excel-reference.component.html',
  styleUrls: ['./import-receiving-excel-reference.component.css']
})
export class ImportReceivingExcelReferenceComponent implements OnInit {
  Customer=[];
  ArrayLocations = []
  viewRegistrosMasivos = false
  datosArrayExcel: mensajesArrayExcel
  arrayMensajesMasivoExcel: mensajesArrayExcel[]
  productosMensajes = []
  DatosProductsAdd: RequestProductsAdd
  valorCustomerMasivo=''
  constructor (
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    public dialogRef: MatDialogRef<ImportReceivingExcelReferenceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.arrayMensajesMasivoExcel = []
    this.ArrayLocations = []
    this.Customer=[];
    this.OnSelectLocations();
    this.OnSelectCostumer();
  }

  onNoClick (): void {
    this.dialogRef.close()
  }

  ngOnInit (): void {}
  public files2: NgxFileDropEntry[] = []

  public dropped2 (files: NgxFileDropEntry[]) {
    this.files2 = files
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry
        fileEntry.file((file: File) => {
          // Here you can access the real file
          console.log(droppedFile.relativePath, file)
          let workBook = null
          let jsonData = null
          var reader = new FileReader()

          reader.onload = event => {
            const data = reader.result
            workBook = XLSX.read(data, { type: 'binary' })
            jsonData = workBook.SheetNames.reduce((initial, name) => {
              const sheet = workBook.Sheets[name]
              initial[name] = XLSX.utils.sheet_to_json(sheet)
              return initial
            }, {})

            for (let index = 0; index < jsonData.receiving.length; index++) {
try {
  this.OnSaveOrUpdate(index,this.valorCustomerMasivo,jsonData.receiving[index].references,jsonData.receiving[index].eta,new Date(new Date()),'','','',jsonData.receiving[index].container,'','',0,'','',1,0,0,0,0,jsonData.receiving[index].location,jsonData.receiving[index].itemnumber,'',jsonData.receiving[index].quantity,null,'','',jsonData.receiving[index].pallet) 

} catch (error) {
  
}

            }

          
          }

          reader.readAsBinaryString(file)
        })
      } else {
      }
    }
    this.viewRegistrosMasivos = true
  }
  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.arrayMensajesMasivoExcel
    ); //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'items');
  
    /* save to file */
    XLSX.writeFile(wb, 'importShipping.xlsx');
  }
  OnSelectCostumer () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['CompanyId'] = String(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['Active'] = String('1')

    this.http
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token
        })
      })
      .subscribe((response: any) => {
        this.Customer = response
      })
  }
  public fileOver2 (event) {
    console.log(event)
  }

  public fileLeave2 (event) {
    console.log(event)
  }

  OnSelectLocations () {
    var Request = {}
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )

    this.http
      .post<any>(
        `${environment.apiUrl}/Administracion/SerchLocations`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.ArrayLocations = response
      })
  }

  filterDataCustomerSearchOrder(locationName: string) {
	  return this.ArrayLocations.filter((object) => {
		if (String(object.Location).toUpperCase() == String(locationName).toUpperCase()) {
		  return object;
		}
	  });
	}
  OnSaveOrUpdate(index:any,tblCustomerID:any,ReferenceNumber:any,ETA:any,
    ReceivedDate:any,CarrierName:any,
    BOLNumber:any,PONumber:any,
    ContainerNumber:any,SealNumber:any,MiscText:any,CapacityType:any,
    DoorNumber:any,NotesR:any,TotalPallets:any,Billed:any,AllChargesAdded:any,HandlingCharge:any,ShortTermStorage:any,
    Location:any,itemNumber:any,lotNumber:any,statedQuantity:any,expirationDate:any,notes:any,
    serialNumber:any,pallex:any) {
   
    var Request = {};
  
    Request['tipo'] = 0;

    Request['tblCompanyID'] = String(
      this.authenticationService.currentUserValue.companyIdWh
    );
    Request['tblCustomerID'] = String(
      tblCustomerID
    );
    Request['ReferenceNumber'] = String(
      ReferenceNumber
    );
    Request['ETA'] = ETA;
    Request['ReceivedDate'] =  ReceivedDate;
    Request['CarrierName'] = String(
      CarrierName
    );
    Request['BOLNumber'] = String(
      BOLNumber
    );
    Request['PONumber'] = String(PONumber);
    Request['ContainerNumber'] = String(
      ContainerNumber
    );
    Request['SealNumber'] = String(
      SealNumber
    );
    Request['MiscText'] = String(
      MiscText
    );
    Request['CapacityType'] = String(
      CapacityType
    );
    Request['DoorNumber'] = String(
      DoorNumber
    );
    Request['Notes'] = String(NotesR);
    Request['Completed'] = '0';
    Request['CompletedDate'] = '';
    Request['DateCreated'] = new Date(new Date());
    Request['TotalPallets'] = String(
      TotalPallets
    );

    Request['Users'] = String(
      this.authenticationService.currentUserValue.useremail
    );

    Request['Billed'] = Number(
      Billed
    );
    //this.FormReceivingProducts.controls.AllChargesAdded.value
    Request['AllChargesAdded'] = Number(AllChargesAdded);
    Request['HandlingCharge'] = Number(
      HandlingCharge
    );
    Request['ShortTermStorage'] = Number(
      ShortTermStorage
    );

    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    this.http
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProductsNewEdit`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token,
          }),
        }
      )
      .subscribe((response: any) => {
     
        try {
          var ids = String(response.responses);
          var rep = ids
            .replace('receiving-new-', '')
            .replace('receiving-edit-', '');
         this.onAddItem(index,rep,Location,itemNumber,lotNumber,statedQuantity,expirationDate,notes,serialNumber,pallex)
        } catch (error) {
          console.log('erroritems',error)
        }
      });
  }

  onAddItem(index:any,tblReceivingProductsID:any,Location:any,itemNumber:any,lotNumber:any,statedQuantity:any,expirationDate:any,notes:any,
    serialNumber:any,pallex:any){

   
      var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
var lo=this.filterDataCustomerSearchOrder(String(Location))

console.log(lo,Location)
      var z = {
        tipo: 0,
        tblReceivingProductsID: Number(tblReceivingProductsID),
        Company_ID:Number(this.authenticationService.currentUserValue.companyIdWh),
        itemNumber: String(itemNumber),
        lotNumber: String(lotNumber||''),
        statedQuantity: String(statedQuantity||'1'),
        actualQuantity: '0',
        discrepancy: '0',
        availableQuantity: '0',
        tblLocationID: String(lo[0].id),
        expirationDate: expirationDate||'sin',
        notes: String(notes||''),
        serialNumber:  String(serialNumber||''),
        completed: 0,
        pallex: String(pallex||'1'),
        completedDate: new Date(new Date())
      }
      console.log(z)

     this.http
        .post<any>(`${environment.apiUrl}/Receive/ReceiveItemsbyExcel`, z, {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        })
        .subscribe((response: any) => {
          try {
            var res = String(response.responses)
            this.datosArrayExcel = {
              celda: String(index),
              itemname: String("RECEIVE#"+tblReceivingProductsID+"-ITEMNUMBER-"+itemNumber || ''),
              mensajes: res
            }

            this.arrayMensajesMasivoExcel.push(this.datosArrayExcel)
          } catch (error) {}
        }) 
    
  }

}
